var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"hide-default-footer":"","items":_vm.updateBomProductQuantityItem,"disable-pagination":""},scopedSlots:_vm._u([{key:"item.srNo",fn:function({item}){return [_vm._v(" "+_vm._s(_vm.updateBomProductQuantityItem.indexOf(item)+1)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }